import React, { FC, useState, useEffect, ChangeEvent } from 'react';
import { Checkbox, Grid, Typography } from '@mui/material';
import { DotLottleLoader } from '../../components/Loader';
import { startCase } from 'lodash';
import toast from 'react-hot-toast';
import { IContentType } from './components/ContentTypeList';
import axiosInstant from '../../api';

interface Props {
  onUpdate?: (types: IContentType[]) => void;
  contentTypes?: Array<IContentType>;
}

const ContentTypeSelector: FC<Props> = ({ contentTypes, onUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [contentTypeList, setContentTypeList] = useState<IContentType[]>([]);

  const searchContentTypes = async () => {
    setLoading(true);
    try {
      const { data: response } = await axiosInstant.get('/content-types');
      setContentTypeList(response || []);
    } catch (e) {
      toast.error('Failed to load content types');
      setContentTypeList([]);
    }
    setLoading(false);
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement>,
    type: IContentType
  ) => {
    let tmpContentTypes = [...(contentTypes || [])];
    if (e.target.checked) tmpContentTypes.push(type);
    else tmpContentTypes = tmpContentTypes.filter((ct) => ct.id !== type.id);
    onUpdate?.(tmpContentTypes);
  };

  useEffect(() => {
    searchContentTypes();
  }, []);

  return (
    <div className="py-4 flex flex-col">
      <span className="text-base font-bold text-left block mb-4 mt-3">
        Content Types
      </span>

      <Grid container spacing={2} className="w-full">
        {contentTypeList.map((type, i) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
            <div className="flex gap-2 py-3">
              <Checkbox
                className="!p-0 h-fit"
                checked={contentTypes?.some((ct) => ct.id === type.id)}
                onChange={(e) => handleChange(e, type)}
              />
              <div className="text-base flex flex-col">
                {startCase(type.name)}
                {type.expert_connect && (
                  <span className="text-xs text-muted">
                    (Portal Enabled)
                  </span>
                )}
              </div>
            </div>
          </Grid>
        ))}
      </Grid>

      {loading && (
        <div className="flex justify-center items-center">
          <DotLottleLoader fill={false} />
        </div>
      )}
    </div>
  );
};

export default ContentTypeSelector;
